/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dco-dialog.vue?vue&type=template&id=f810b592&scoped=true&"
import script from "./dco-dialog.vue?vue&type=script&lang=js&"
export * from "./dco-dialog.vue?vue&type=script&lang=js&"
import style0 from "./dco-dialog.vue?vue&type=style&index=0&id=f810b592&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f810b592",
  null
  
)

export default component.exports